import React from 'react';
import { encodeURIComponentFormWWW } from 'src/scripts/utils/helpers';
import { handleNavigationWithArrowKeys, truncateSearchText } from '../utils';
import { useLocalStorage } from 'usehooks-ts';
import './style.scss';
import { prependLocaleToPath } from '../../../../utils/localization';

const RecentSearchList = () => {
  const [recentSearchLocalStorage, setRecentSearchLocalStorage] = useLocalStorage<Array<string>>(
    `alo-recent-search`,
    []
  );

  const recentSearchLog = recentSearchLocalStorage.slice();

  const clearSearchHistory = () => {
    setRecentSearchLocalStorage([]);
  };

  const handleRemoveRecentSearch = (index: number) => {
    const updatedRecentSearches = [...recentSearchLog];
    updatedRecentSearches.splice(index, 1);
    setRecentSearchLocalStorage(updatedRecentSearches.reverse());
  };

  return recentSearchLocalStorage?.length > 0 ? (
    <div className="recent-search-block d-flex flex-column" role="list">
      <div className="d-flex align-items-center header-container">
        <h6 className="header-title h6">Recent Searches</h6>
        <button className="clear-history lowercase-button" onClick={clearSearchHistory}>
          Clear All
        </button>
      </div>
      <ul className="d-flex ml-0 search-items-list notranslate">
        {recentSearchLog.reverse().map((recentSearch: string, index: number) => {
          const url = prependLocaleToPath(`/search?q=${encodeURIComponentFormWWW(recentSearch)}`);
          const trimmedRecentSearchString = truncateSearchText(recentSearch, 32);
          return (
            <li
              key={index}
              tabIndex={-1}
              className="search-product main-navbar__sub-sub-item search-link d-flex"
              onKeyDown={(e) => {
                handleNavigationWithArrowKeys(e, url);
              }}
            >
              <a data-link-type="sta_recent_search" href={url} rel="recentsearch">
                <span> {trimmedRecentSearchString} </span>
              </a>
              <button
                onClick={() => handleRemoveRecentSearch(index)}
                className="remove-search-btn d-flex align-items-center"
              >
                <span className="alo-cross-primary-icon" style={{ width: '16px', height: '16px' }}></span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};

export default RecentSearchList;
